import { useContext } from "react";
import { MultiStepFormContext } from "@/providers";

export const useMultiStepForm = () => {
  const context = useContext(MultiStepFormContext);
  if (!context) {
    throw new Error("useMultiStepForm must be used within a MultiStepFormProvider");
  }
  return context;
};
